<template>
    <div class="student">
      <van-nav-bar
        title="监护人信息"
        left-text="返回"
        left-arrow
        @click-left="$router.go('-1')"
      />

      <van-cell-group inset style="margin-top:10px">
        <van-form ref="form" @submit="onSubmit" name="info">
        <van-field
          v-model="tel"
          type="digit"
          clearable
          name="tel"
          ref = "inputmobile"
          :rules="userTel"
          placeholder="请输入手机号" 
        />
        <van-field
          v-model="sms"
          center
          clearable
          placeholder="请输入短信验证码"
          type="digit"
          >
          <template #button>
              <van-button
              type="primary"
              @click="sendCode"
              :disabled="disabled"
              native-type="button">
              {{codeMsg}}
              </van-button>
          </template>
      </van-field>
       </van-form>
      </van-cell-group>
  
      <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="onSubmit" >绑  定</van-button>
        </div>
    
    </div>
  </template>
  
  <script>
  import { NavBar, Cell, CellGroup,Button,Form, Field,Cascader,Toast  } from 'vant'


  export default {
    data() {
      return {
      
        tel: "",
      sms: "",
      disabled: false,
      codeNum: 90,
      codeMsg: "获取短信验证码",
      userTel: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "onBlur"
        },
        {
          validator: value => {
            return /^1[23456789]\d{9}$/.test(value);
          },
          message: "请输入正确格式的手机号"
        }
      ]
        
      }
    },
    created() {
     
    },
    methods: {
      onSubmit:function(){
       
        var student =JSON.parse(localStorage.getItem("bindStudentinfo"));
        var guardian = JSON.parse(localStorage.getItem("bindGuardianInfo"))
        console.log("getguardian",localStorage.getItem("bindGuardianInfo"))
        if (student==null){
          Toast.fail("未选择学生")
          return;
        }
        console.log("student",student.studentid);
        if(this.tel==""){
          Toast("请填写号码");
          return;
        }
        if(this.sms==""){
          Toast("请填写验证码");
          return;
        }
        this.$http
          .json_post(this.$api.baseinfo.verifysmscode, {
            Phone : this.tel,
            Smscode:this.sms
          })
          .then(data => {
            console.log("data",data);
            var saddguard=localStorage.getItem("addGuardianFalg")
            var addguard = JSON.parse(saddguard)
           // alert(JSON.stringify(addguard))
            if (data.code==0){
              if (addguard.addFlag ==0){
                
                this.$http
                  .json_post(this.$api.baseinfo.bindguardian, {
                    Phone:this.tel,
                    Studentid : eval(student.studentid)
                  })
                  .then(data => {
                    console.log("data",data);
                    if (data.code===0){
                      Toast.success('绑定成功');
                      this.$router.push({ name: 'home',query:{newsession:true} })
                    }else {
                      Toast.fail(data.msg);
                    }
                  })
                  return
                
              }
              if (addguard.addFlag==1) {
                this.$http
                    .json_post(this.$api.baseinfo.bindaddguardian, {
                      Studentid : eval(student.studentid),
                      Relation :guardian.Relation,
                      Guardianname: guardian.Guardianname,
                      Addr:guardian.Addr,
                      Phone:this.tel,
                      Ismaster:eval(student.Ismaster),
                      Unitname:guardian.Unitname,
                      Unitaddr:guardian.Unitaddr
                    })
                    .then(data => {
                      console.log("data",data);
                      if (data.code===0){
                        Toast.success('绑定成功');
                        //this.$router.push('/devicescan');
                        this.$router.push({ name: 'devicescan',query:{studentid:student.studentid,studentname:student.studentname} })

                      }else {
                        Toast.fail(data.msg);
                      }
                    })
              }else {
                  Toast("未定义添加方式")
              }
            }else {
              Toast.fail(data.msg);
            }
          })
        //console.log(student.studentid);
        //this.$router.push('/devicescan');
      },
      sendCode(){
          // 验证手机号格式是否正确
        if (!this.userTel[1].validator(this.tel)) {
          this.$refs.inputmobile.focus()
          return;
        }

        // 禁用按钮
        this.disabled = true;
        this.$http
            .json_post(this.$api.baseinfo.getsmscode, {
              Phone : this.tel
            })
            .then(data => {
              console.log("data",data);
              if (data.code===0){
                this.codeMsg = `重新发送(${this.codeNum})`;
                // 倒计时
              var timer = setInterval(() => {
                --this.codeNum;
                this.codeMsg = `重新发送(${this.codeNum})`;
              }, 1000);
              // 判断什么时候停止定时器
              setInterval(() => {
                clearInterval(timer);
                this.codeNum = 90;
                this.disabled = false;
                this.codeMsg = "获取短信验证码";
              }, 90000);
              }else {
                Toast.fail(data.msg);
                this.disabled = false;
                this.codeMsg = "获取短信验证码";
              }
        })
      },
      bindguardian:function(){
        this.$http
          .json_post(this.$api.baseinfo.bindguardian, {
            phone : this.guardian.phone
          })
          .then(data => {
            console.log("data",data);
            if (data.code===0){
              Toast("绑定成功");
              this.$router.push("/home");
            }else {
              Toast.fail(data.msg);
            }
          })
      },
      onRelationFinish:function(values){
        console.log(values);
        this.guardian.relation=values.selectedOptions[0].text;
        
        this.showRelation =false;
      }
    },
    components: {
      'van-nav-bar': NavBar,
      'van-cell-group': CellGroup,
      'van-cell': Cell,
      'van-field':Field,
      'van-cascader':Cascader ,
      'van-button':Button
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .icon-xuesheng {
    color: $primary-color;
  }
  </style>
  